import React, { useEffect, useState } from 'react'
import DataTable from '../../../component/data_table/DataTable'
import AddButton from '../../../component/buttons/AddButton';
import { Link, useNavigate } from 'react-router-dom';
import { FilePenLine, Trash2 } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../../component/loader/Loader';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { designationListTodo } from '../../../redux/slices/master/designation/DesignationList';
import { deleteDesignationTodo } from '../../../redux/slices/master/designation/DeleteDesignation';
import { Tooltip } from 'react-tooltip';

export default function DesignationList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const designationList = useSelector(state => state?.designationList?.data?.data)

    useEffect(() => {
        setLoading(true)
        dispatch(designationListTodo({ navigate })).then((res) => list_res(res?.payload))
    }, [bool])

    const list_res = (res) => {
        if (res?.status) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const editUser = (data) => {
        navigate('/update-designation', { state: data })
    }

    const deleteUser = (data) => {
        Swal.fire({
            title: "Designation Delete",
            text: 'Are you sure want to delete',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#121136',
            cancelButtonColor: '#EF3D50',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Confirm'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteDesignationTodo(data)).then((res) => del_res(res))
            }
        })
    }

    const del_res = (res) => {
        if (res?.payload?.status == 204) {
            setBool(!bool)
            Swal.fire({
                title: 'Designation',
                text: res?.data?.massage,
                icon: 'success',
                confirmButtonText: 'OK'
            })

        } else if (res?.payload?.status == 401) {
            localStorage.clear();
            navigate('/login')
        } else if (res?.payload?.status == 400) {
            toast.error(res?.payload?.data?.messagea?.message, { position: "bottom-right" });
        } else if (res?.payload?.status == 404) {
            toast.error('Not Found', { position: "bottom-right" });
        } else {
            toast.error(res?.payload?.data?.message, { position: "bottom-right" });
        }
    }



    const columnDefs = [
        {
            headerName: 'S.NO',
            maxWidth: 90,
            valueGetter: 'node.rowIndex + 1',
            sortable: true,
        },
        {
            headerName: 'DESIGNATION',
            field: 'name',
            sortable: true,
        },

        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params =>
                params?.data?.status === 'Active'
                    ? <span className='badge text-bg-success'>Active</span>
                    : <span className='badge text-bg-danger'>Inactive</span>,
            sortable: true,
        },
        {
            headerName: 'ACTION',
            cellRenderer: params => (
                <div className='d-flex'>
                    <span
                        onClick={() => editUser(params?.data)}
                        data-tooltip-id='edit'
                        data-tooltip-content="Designation Update"
                        data-tooltip-place="bottom"
                    >
                        <FilePenLine className='text-success' size={20} />
                    </span>
                    {/* <span className='ms-2'
                        data-tooltip-id='delete'
                        data-tooltip-content="Designation Delete"
                        data-tooltip-place="bottom"
                        onClick={() => deleteUser(params?.data?._id)}
                    >
                        <Trash2 className='text-danger' size={20} />
                    </span> */}
                    <Tooltip id='edit' className='bg-success tooltip_msg' />
                    <Tooltip id='delete' className='bg-danger tooltip_msg' />
                </div>
            ),
            autoHeight: true,
        }
    ];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout_head d-flex justify-content-between align-items-center mb-3'>
                            <h5>Designation List</h5>
                            <Link to='/add-designation'>   <AddButton label={"Add Designation"} /> </Link>
                        </div>
                        {loading ?
                            <div className='text-center'>
                                <Loader />
                            </div>
                            :
                            <DataTable
                                rowData={designationList}
                                columnDefs={columnDefs}
                                height={'65vh'}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}
